import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { useBillsQuery } from '../../../api/getBills';
import { useWelcomeQuery } from '../../../api/getWelcomeDetails';

const QuoteFormRedirect = ({ children }: React.PropsWithChildren) => {
  const { data: welcomeData } = useWelcomeQuery();
  const { data: billsData } = useBillsQuery();
  const firstPolicy = billsData?.payments?.[0];

  const policyType = useMemo(() => {
    if (firstPolicy?.policyType === 'Auto') return 'AUTO';

    return firstPolicy?.fullProductCode;
  }, [billsData]);

  return (
    <Stack
      component="form"
      method="post"
      target="_blank"
      action={`${import.meta.env.VITE_QUOTE_URL}/api-external-quoter/v1/redirect`}
    >
      <input name="policyType" type="hidden" value={policyType} />
      {welcomeData?.userInfo?.clubCode ? (
        <input
          name="clubCode"
          type="hidden"
          value={welcomeData?.userInfo?.clubCode}
        />
      ) : (
        <input name="partnerId" type="hidden" value="mypolicy-web" />
      )}

      <input
        name="primaryInsFirstName"
        type="hidden"
        value={welcomeData?.userInfo?.firstName}
      />
      <input
        name="primaryInsLastName"
        type="hidden"
        value={welcomeData?.userInfo?.lastName}
      />
      <input
        name="primaryInsZipCode"
        type="hidden"
        value={firstPolicy?.billingAddress?.postalCode}
      />
      {firstPolicy?.billingAddress?.addressLine1 && (
        <input
          name="primaryInsAddressLine1"
          type="hidden"
          value={firstPolicy?.billingAddress?.addressLine1}
        />
      )}
      {firstPolicy?.billingAddress?.addressLine2 && (
        <input
          name="primaryInsAddressLine2"
          type="hidden"
          value={firstPolicy?.billingAddress?.addressLine2}
        />
      )}
      {firstPolicy?.billingAddress?.city && (
        <input
          name="primaryInsCity"
          type="hidden"
          value={firstPolicy?.billingAddress?.city}
        />
      )}
      {firstPolicy?.billingAddress?.stateProvCd && (
        <input
          name="primaryInsState"
          type="hidden"
          value={firstPolicy?.billingAddress?.stateProvCd}
        />
      )}
      {children}
    </Stack>
  );
};

export default QuoteFormRedirect;
